export default {
  inProgress: 'В процессе',
  ok: 'Успешно',
  success: 'Успешно',
  failed: 'Ошибка',
  redirect: 'Перенаправлена',
  rollback: 'Аннулирована',
  loading: 'Подтверждается',
};
